<div class="flex items-start gap-2">
  <label role="button" for="onlysantander">
    <input type="checkbox" id="onlysantander" class="checkbox" [ngStyle]="{ 'user-select': isDisabled ? 'none' : 'inherit' }" [disabled]="isDisabled" [(ngModel)]="isChecked"
      (ngModelChange)="changeCheckbox.emit($event)" />
    <div class="santander-checkbox mr-4" id="san-checkbox"></div>
  </label>
  <ng-content (click)="$event.preventDefault()"></ng-content>
</div>